import { mergeTeiaSearchFilters } from '@stereograph/teia-system-design/teia-components';
import { TeiaSearchFilter } from '@stereograph/teia-system-design/utils';
import {
  StandardWidget,
  StandardWidgetOptions,
  TeiaViewer,
  TeiaViewerSourceType,
  TwinSource,
  useTeiaSource,
  WidgetContextProviderProps,
  WidgetFactoryFunction,
} from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';
import { TeiaQuantityTakeoffWidgetProvider } from '../components/TeiaQuantityTakeoffProvider';
import { TeiaQuantityTakeoffWidgetContent } from './TeiaQuantityTakeoffWidgetContent';
import { TeiaQuantityTakeoffWidgetFooter } from './TeiaQuantityTakeoffWidgetFooter';

declare global {
  interface ViewerWidgetRegistry {
    TeiaQuantityTakeOff: WidgetFactoryFunction<
      TeiaQuantityTakeoffWidget,
      TeiaQuantityTakeoffWidgetOptions
    >;
  }
}

export interface TeiaQuantityTakeoffWidgetOptions extends StandardWidgetOptions {
  searchRules: TeiaSearchFilter;
}

export class TeiaQuantityTakeoffWidget extends StandardWidget {
  readonly type = 'TeiaQuantityTakeOff';
  searchRules: TeiaSearchFilter;
  private readonly isTwinSource: boolean;

  constructor(viewer: TeiaViewer, options: TeiaQuantityTakeoffWidgetOptions) {
    const { searchRules, ...otherOptions } = options;

    super(viewer, {
      size: 'compact',
      minWidth: 400,
      minHeight: 400,
      ...otherOptions,
    });
    this.isTwinSource = viewer.currentSource?.sourceType === TeiaViewerSourceType.Twin;
    const twinFilter = this.isTwinSource ? ((viewer.currentSource as TwinSource).filter ?? {}) : {};
    this.searchRules = mergeTeiaSearchFilters([twinFilter, searchRules]);
  }

  override Header = function Header() {
    const { t } = usePluginTranslation();

    return t('quantity_takeoff_plugin.title');
  };

  override Content = function Content() {
    return <TeiaQuantityTakeoffWidgetContent />;
  };

  override Footer = function Footer() {
    const twin = useTeiaSource(TeiaViewerSourceType.Twin);
    if (!twin) {
      return null;
    }

    return <TeiaQuantityTakeoffWidgetFooter />;
  };

  override ContextProvider = (props: WidgetContextProviderProps) => {
    if (!this.isTwinSource) {
      return null;
    }

    return <TeiaQuantityTakeoffWidgetProvider {...props} searchRules={this.searchRules} />;
  };
}
